import $ from "jquery";

const tr_link = () => {
  $("tr[data-link]").on("click", function (e) {
    const target = e.target;
    const tag = target.tagName.toLowerCase();

    if (tag === "i" || tag === "a") return;

    // Skip navigation when click happens inside an interactive Bootstrap dropdown
    // (trigger or menu) so badges/dropdowns inside the row remain usable.
    if (target.closest('[data-bs-toggle="dropdown"]')) return;
    if (target.closest(".dropdown-menu")) return;

    window.location = $(this).data("link");
  });
};

export { tr_link };
